<div class="supporting-document-preview-container">
	@if (isLoading()) {
		<div class="loading-state">
			<p>Loading documents...</p>
		</div>
	} @else if (documents().length === 0) {
		<div class="empty-state">
			<p>No documents available for preview. Please upload documents on the Documents tab.</p>
		</div>
	} @else {
		<flx-tabs
			[tabs]="tabs()"
			[currentStep$]="currentTabObservable$"
			[externalPages]="true"
			(outputEventStream)="handleTab($event)"
		>
			<div class="preview-header">
				<!-- <h3 class="document-title">{{ getCurrentDocument()?.documentLabel || 'Document Preview' }}</h3> -->
				<div class="zoom-controls">
					<button type="button" class="zoom-button" (click)="zoomOut()" [disabled]="zoomLevel() <= 0.5">
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
							<line x1="8" y1="11" x2="14" y2="11"></line>
						</svg>
					</button>
					<span class="zoom-level">{{ Math.round(zoomLevel() * 100) }}%</span>
					<button type="button" class="zoom-button" (click)="zoomIn()" [disabled]="zoomLevel() >= 5">
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
							<line x1="11" y1="8" x2="11" y2="14"></line>
							<line x1="8" y1="11" x2="14" y2="11"></line>
						</svg>
					</button>
					<button type="button" class="zoom-button reset-button" (click)="resetZoom()">
						Reset
					</button>
					<button
						type="button"
						class="zoom-button"
						(click)="rotateLeft()"
						[disabled]="getCurrentDocumentMimeType() !== 'image'"
						title="Rotate left"
					>
						<span>Rotate ⟲</span>
					</button>
					<button
						type="button"
						class="zoom-button"
						(click)="rotateRight()"
						[disabled]="getCurrentDocumentMimeType() !== 'image'"
						title="Rotate right"
					>
						<span>Rotate ⟳</span>
					</button>
				</div>
			</div>

			@for (tab of tabs(); track tab.targetId) {
				@if (currentTab$() === tab.targetId) {
					<div
						class="tab-content"
						[attr.contents]="tab.targetId"
					>
					<div
						class="document-viewer"
						(mousedown)="onMouseDown($event)"
						(mousemove)="onMouseMove($event)"
						(mouseup)="onMouseUp()"
						(mouseleave)="onMouseLeave()"
						(wheel)="onWheel($event)"
						[class.dragging]="isDragging()"
					>
						@if (getCurrentDocumentMimeType() === 'image') {
							<div class="image-viewer-container">
								<div
									class="image-transform-wrapper"
									[style.transform]="getImageTransform()"
									[style.transform-origin]="'0 0'"
								>
									<img
										[src]="getCurrentDocumentUrl()"
										[style.transform]="'rotate(' + imageRotation() + 'deg)'"
										[style.transform-origin]="'50% 50%'"
										class="preview-image"
										draggable="false"
									/>
								</div>
							</div>
						} @else if (getCurrentDocumentMimeType() === 'pdf') {
							<div class="pdf-viewer-container">
								<div class="pdf-controls">
									<button
										type="button"
										class="page-button"
										(click)="previousPage()"
										[disabled]="pdfPageNum() <= 1"
									>
										Previous
									</button>
									<span class="page-info">
										Page {{ pdfPageNum() }} of {{ pdfTotalPages() }}
									</span>
									<button
										type="button"
										class="page-button"
										(click)="nextPage()"
										[disabled]="pdfPageNum() >= pdfTotalPages()"
									>
										Next
									</button>
								</div>
								<div class="pdf-canvas-container">
									<canvas
										#pdfCanvas
										class="pdf-canvas"
										[style.transform]="getImageTransform()"
										[style.transform-origin]="'0 0'"
									></canvas>
								</div>
							</div>
						} @else {
							<div class="unsupported-file">
								<p>File type not supported for preview</p>
							</div>
						}
					</div>
					</div>
				}
			}
		</flx-tabs>
	}
</div>

